import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// common
import common from "../features/admin/common/Slice";
// masters
import masters from "./masters";

import usermanagement from "./usermanagement";

import customerManagement from "../features/admin/customer_management/Slice";

import sample_management from "../features/admin/sample_management/Slice";
import instrument_management from "../features/admin/instrument_management/Slice";
import consumable_item from "../features/admin/consumable_item/Slice";
import serial from "../features/admin/serial_counter/Slice";
import profile from "../features/admin/Profile/Slice";
import imperiality from "../features/admin/quality_management/general_requirement/imperiality/Slice";
import confidentiality from "../features/admin/quality_management/general_requirement/confidentiality/Slice";
import legal_entity from "../features/admin/quality_management/structural_requirement/legal_entity/Slice";
import quality_policy from "../features/admin/quality_management/structural_requirement/quality_policy/Slice";
import scope_of_laboratory from "../features/admin/quality_management/structural_requirement/scope_of_laboratoy/Slice";
import management_data from "../features/admin/quality_management/structural_requirement/management_data/Slice";
import metrological_traceability from "../features/admin/quality_management/resource_requirement/metrological_traceability/Slice";
import calibration_item from "../features/admin/quality_management/process_requirement/calibration_item/Slice";
import complaint from "../features/admin/quality_management/process_requirement/complaint/Slice";
import repeatability from "../features/admin/quality_management/process_requirement/repeatability/Slice";
import quality_control_plan from "../features/admin/quality_management/process_requirement/quality_control/Slice";
import measurement_type_data from "../features/admin/quality_management/process_requirement/measurement_uncertainty/Slice";

import validity from "../features/admin/quality_management/process_requirement/validity/Slice";
import non_confirming_work from "../features/admin/quality_management/process_requirement/non_confirming_work/Slice";
import accuracy from "../features/admin/quality_management/process_requirement/accuracy/Slice";

import management_system from "../features/admin/quality_management/management_system/Slice";

import personnel_details from "../features/admin/quality_management/resource_requirement/personal_detail/Slice";

import training_details from "../features/admin/quality_management/resource_requirement/training_details/Slice";
import environmental_condition from "../features/admin/quality_management/resource_requirement/environmentcondition/Slice";
import externally_provided from "../features/admin/quality_management/resource_requirement/externaldetails/Slice";

import external_audit from "../features/admin/external_audit/Slice";
import external_log from "../features/admin/external_log/Slice";

import certificateManagement from "../features/admin/certificate_generation/Slice";

import ReportsGenerator from "../features/admin/report_generator/Slice";
import equipment from "../features/admin/quality_management/resource_requirement/equipment/Slice";

import objective from "../features/admin/quality_management/structural_requirement/objective/Slice";

import dashboard from "../features/admin/dashboard/Slice";

import tender from "../features/admin/quality_management/process_requirement/tender/Slice";
export const store = configureStore({
  reducer: {
    settings: settings,
    auth: auth,
    common: common,

    masters,
    customerManagement: customerManagement,
    sample_management: sample_management,
    usermanagement: usermanagement,
    instrument_management: instrument_management,
    serial: serial,
    consumable_item: consumable_item,
    profile: profile,
    imperiality: imperiality,
    confidentiality: confidentiality,
    legal_entity: legal_entity,
    quality_policy: quality_policy,
    scope_of_laboratory: scope_of_laboratory,
    management_data: management_data,
    metrological_traceability: metrological_traceability,
    calibration_item: calibration_item,
    personnel_details: personnel_details,
    environmental_condition: environmental_condition,
    externally_provided: externally_provided,
    complaint: complaint,
    certificateManagement: certificateManagement,
    repeatability: repeatability,
    quality_control_plan: quality_control_plan,
    validity: validity,
    ReportsGenerator: ReportsGenerator,
    non_confirming_work: non_confirming_work,
    management_system: management_system,
    accuracy: accuracy,

    external_audit: external_audit,
    equipment: equipment,
    measurement_type_data: measurement_type_data,
    objective: objective,
    dashboard: dashboard,
    training_details: training_details,
    tender:tender,
    external_log:external_log
  },
});
